import LockTime from './LockTime';

export default LockTime;
